import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const AlmostThere = lazyWithPreload(() => import('./AlmostThere'))
